import React, { useCallback, useEffect, useState, useRef } from 'react';
const PROOF_DATA = [{
  name: 'Sarah',
  city: 'Dallas',
  ago: '2 min ago'
}, {
  name: 'Jessica',
  city: 'Miami',
  ago: '4 min ago'
}, {
  name: 'Alyssa',
  city: 'Chicago',
  ago: '7 min ago'
}, {
  name: 'Maria',
  city: 'Los Angeles',
  ago: '11 min ago'
}, {
  name: 'Tanya',
  city: 'Atlanta',
  ago: '14 min ago'
}, {
  name: 'Brianna',
  city: 'Houston',
  ago: '17 min ago'
}, {
  name: 'Nicole',
  city: 'Phoenix',
  ago: '21 min ago'
}, {
  name: 'Keisha',
  city: 'Brooklyn',
  ago: '24 min ago'
}, {
  name: 'Amanda',
  city: 'Denver',
  ago: '28 min ago'
}, {
  name: 'Priya',
  city: 'San Jose',
  ago: '32 min ago'
}, {
  name: 'Danielle',
  city: 'Seattle',
  ago: '36 min ago'
}, {
  name: 'Camila',
  city: 'Austin',
  ago: '40 min ago'
}];
const MAX_POPUPS = 8;
const MIN_INTERVAL = 45000;
const MAX_INTERVAL = 60000;
const DISPLAY_DURATION = 6000;
const SCROLL_THRESHOLD = 0.5;
const LINGER_TIMEOUT = 20000;
export function SocialProof() {
  const [current, setCurrent] = useState<(typeof PROOF_DATA)[0] | null>(null);
  const [show, setShow] = useState(false);
  const shownCount = useRef(0);
  const indexRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const activated = useRef(false);
  const showNext = useCallback(() => {
    if (shownCount.current >= MAX_POPUPS) return;
    const item = PROOF_DATA[indexRef.current % PROOF_DATA.length];
    indexRef.current++;
    shownCount.current++;
    setCurrent(item);
    setShow(true);
    hideTimerRef.current = setTimeout(() => {
      setShow(false);
    }, DISPLAY_DURATION);
    if (shownCount.current < MAX_POPUPS) {
      const delay = MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL);
      timerRef.current = setTimeout(showNext, delay);
    }
  }, []);
  const activate = useCallback(() => {
    if (activated.current) return;
    activated.current = true;
    const initialDelay = 3000 + Math.random() * 5000;
    timerRef.current = setTimeout(showNext, initialDelay);
  }, [showNext]);
  useEffect(() => {
    const lingerTimer = setTimeout(activate, LINGER_TIMEOUT);
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrollPercent >= SCROLL_THRESHOLD) activate();
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      clearTimeout(lingerTimer);
      window.removeEventListener('scroll', handleScroll);
      if (timerRef.current) clearTimeout(timerRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, [activate]);
  if (!current) return null;
  return <div className={`fixed bottom-4 left-4 z-30 transition-all duration-500 ${show ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-248">
      <div className="bg-white rounded-xl shadow-xl border border-charcoal/10 p-2.5 flex items-center gap-2.5 max-w-[280px]" data-id="element-249">
        <img src="https://cdn.magicpatterns.com/uploads/kGVLSUQm3HPCmdkSXZAaKT/Final_Mockup.png" alt="Ebook" className="w-10 h-10 rounded-lg object-cover flex-shrink-0" data-id="element-250" />
        <div className="min-w-0" data-id="element-251">
          <p className="text-charcoal text-[11px] md:text-xs font-medium leading-snug" data-id="element-252">
            {current.name} from {current.city}
          </p>
          <p className="text-charcoal/50 text-[9px] md:text-[10px] font-light leading-snug" data-id="element-253">
            purchased{' '}
            <span className="font-medium text-navy" data-id="element-254">
              Who Programmed You to Spend?
            </span>
          </p>
          <p className="text-charcoal/40 text-[9px] font-light" data-id="element-255">
            {current.ago}
          </p>
        </div>
      </div>
    </div>;
}